import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/cros.svg")